import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from 'rtk/query/axiosBaseQuery';
import config from 'config/index';
import { EUserType } from 'types/accessControll.types';
import type { BrevoTemplateListResponse } from 'types/brevo.types';

const reducerPath = 'brevo' as const;
const path = 'v1/email' as const;

export const brevoApi = createApi({
  reducerPath: reducerPath,
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.VITE_BACKEND_URL}/${path}`,
  }),
  endpoints: (builder) => ({
    getAllBrevoTemplates: builder.query<BrevoTemplateListResponse, void>({
      query: () => ({
        url: `/get-all-templates`,
        method: 'GET',
        headers: { 'X-Access-Control': EUserType.HUBERT },
      }),
    }),
  }),
});
